import { type Clip } from '@air/api/types';
import { clipToCanvasAssetPayload, filterImageAssets } from '@air/feature-edit-canvas';

/** Clips that can land on a canvas, in the same order they were loaded. */
export const getCanvasEligibleClips = (clips: Clip[]): Clip[] => {
  const { imageAssets, videoAssets } = filterImageAssets(clips.map((clip) => clipToCanvasAssetPayload(clip)));
  const acceptedIds = new Set([...imageAssets, ...videoAssets].map((asset) => asset.id));

  return clips.filter((clip) => acceptedIds.has(clip.id));
};
